export default {
  primaryColor: "#1890FF",
  // vue-ls options
  storageOptions: {
    namespace: "pro__", // key prefix
    name: "ls", // name variable Vue.[ls] or this.[$ls],
    storage: "local", // storage name session, local, memory
  },
};
